export const WORKSPACE_COLORS = [
  "#3b82f6", "#6366f1", "#8b5cf6", "#ec4899",
  "#ef4444", "#f97316", "#f59e0b", "#22c55e",
  "#06b6d4", "#64748b",
];

export const WORKSPACE_EMOJIS = [
  "colony",
  "🏭", "🚀", "💡", "🔧", "⚡", "🎯", "🏗️", "📦",
  "🌍", "💎", "🔬", "🎨", "📊", "🛡️", "🌱", "🔥",
  "💻", "🧪", "📱", "🎮", "🤖", "🧠", "⭐", "🏆",
  "🎵", "📸", "✈️", "🏠", "💰", "📚",
];
